import React from 'react';
import { 
   Nav, 
   NavbarContainer,
   NavLogo, 
} from './NavbarElements';


const Navbar = ({}) => {
   return (
      <React.Fragment>
         <Nav>
            <NavbarContainer>
               <NavLogo to='/'>BalmaDev</NavLogo>
            </NavbarContainer>
         </Nav>
      </React.Fragment>
   );
};

export default Navbar

